import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function AtendenteComanda() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [comanda, setComanda] = useState(null);
  const [produtos, setProdutos] = useState({});
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('itens'); // itens | adicionar | pagamento
  const [busca, setBusca] = useState('');
  const [toast, setToast] = useState('');
  const [modalPagamento, setModalPagamento] = useState(false);
  const [novoPag, setNovoPag] = useState({ forma: 'dinheiro', valor: '' });

  const token = localStorage.getItem('funcionario_token');
  const api = axios.create({
    baseURL: `${API_URL}/api`,
    headers: { Authorization: `Bearer ${token}` }
  });

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  useEffect(() => {
    if (!token) return navigate('/atendente/login');
    carregar();
    carregarProdutos();
  }, [id]);

  const carregar = async () => {
    try {
      const r = await api.get(`/comandas/${id}`);
      setComanda(r.data);
    } catch (err) {
      if (err.response?.status === 401) navigate('/atendente/login');
    } finally { setLoading(false); }
  };

  const carregarProdutos = async () => {
    try {
      const r = await axios.get(`${API_URL}/api/produtos`);
      setProdutos(r.data);
    } catch {}
  };

  const adicionarItem = async (produto) => {
    try {
      await api.post(`/comandas/${id}/itens`, { produto_id: produto.id, quantidade: 1 });
      showToast(`✅ ${produto.nome} adicionado`);
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const removerItem = async (itemId) => {
    if (!window.confirm('Remover este item?')) return;
    try {
      await api.delete(`/comandas/${id}/itens/${itemId}`);
      showToast('✅ Removido');
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const adicionarPagamento = async () => {
    if (!novoPag.valor || parseFloat(novoPag.valor) <= 0) return showToast('⚠️ Valor inválido');
    try {
      await api.post(`/comandas/${id}/pagamentos`, {
        forma: novoPag.forma,
        valor: parseFloat(novoPag.valor)
      });
      setNovoPag({ forma: 'dinheiro', valor: '' });
      setModalPagamento(false);
      showToast('✅ Pagamento registrado');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const removerPagamento = async (pagId) => {
    if (!window.confirm('Remover este pagamento?')) return;
    try {
      await api.delete(`/comandas/${id}/pagamentos/${pagId}`);
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const fecharComanda = async () => {
    if (!window.confirm('Fechar comanda? Confirme que o pagamento foi realizado.')) return;
    try {
      await api.post(`/comandas/${id}/fechar`);
      showToast('✅ Comanda fechada');
      setTimeout(() => navigate('/atendente/mesas'), 1000);
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const cancelarComanda = async () => {
    if (!window.confirm('CANCELAR esta comanda? Todos os itens serão descartados.')) return;
    try {
      await api.post(`/comandas/${id}/cancelar`);
      showToast('Cancelada');
      setTimeout(() => navigate('/atendente/mesas'), 800);
    } catch { showToast('❌ Erro'); }
  };

  if (loading || !comanda) return <div style={{ padding: 40, textAlign: 'center', color: '#fff' }}>Carregando...</div>;

  const totalPago = (comanda.pagamentos || []).reduce((s, p) => s + parseFloat(p.valor), 0);
  const restante = parseFloat(comanda.total) - totalPago;

  const formasPagLabel = {
    dinheiro: '💵 Dinheiro',
    pix: '📱 PIX',
    cartao_credito: '💳 Cart. Crédito',
    cartao_debito: '💳 Cart. Débito',
    outro: '📌 Outro'
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 100, color: '#fff' }}>
      {toast && <div style={{
        position: 'fixed', top: 70, left: '50%', transform: 'translateX(-50%)',
        background: 'linear-gradient(90deg,#e63946,#FF6B00)', color: '#fff',
        padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999
      }}>{toast}</div>}

      {/* Header */}
      <div style={{ background: 'rgba(0,0,0,0.7)', padding: '12px 16px', borderBottom: '1px solid #333',
        display: 'flex', alignItems: 'center', gap: 10, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate('/atendente/mesas')} style={{
          background: '#333', border: 'none', color: '#fff', padding: '6px 10px',
          borderRadius: 6, cursor: 'pointer', fontSize: 14
        }}>←</button>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 800 }}>
            {comanda.mesa_numero.match(/^\d+$/) ? `Mesa ${comanda.mesa_numero}` : comanda.mesa_numero}
            {comanda.nome_cliente && <span style={{ fontSize: 12, color: '#999', fontWeight: 400 }}> · {comanda.nome_cliente}</span>}
          </div>
          <div style={{ fontSize: 11, color: '#888' }}>Aberta por {comanda.funcionario_nome}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, color: '#888' }}>Total</div>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#FF6B00' }}>
            R$ {parseFloat(comanda.total).toFixed(2).replace('.', ',')}
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', background: '#111', borderBottom: '1px solid #333' }}>
        {[
          { id: 'itens', label: `📋 Itens (${comanda.itens.length})` },
          { id: 'adicionar', label: '➕ Adicionar' },
          { id: 'pagamento', label: '💰 Pagamento' }
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            flex: 1, padding: 12, background: tab === t.id ? '#1a1a1a' : 'transparent',
            border: 'none', color: tab === t.id ? '#FF6B00' : '#999',
            borderBottom: tab === t.id ? '2px solid #FF6B00' : '2px solid transparent',
            fontSize: 12, fontWeight: 700, cursor: 'pointer'
          }}>{t.label}</button>
        ))}
      </div>

      <div style={{ padding: 16 }}>
        {/* Tab: Itens */}
        {tab === 'itens' && (
          <>
            {comanda.itens.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>
                Nenhum item ainda.<br />
                <button onClick={() => setTab('adicionar')} style={{
                  marginTop: 14, background: 'linear-gradient(90deg,#e63946,#FF6B00)',
                  border: 'none', color: '#fff', padding: '10px 18px', borderRadius: 8,
                  cursor: 'pointer', fontSize: 13, fontWeight: 700
                }}>➕ Adicionar Item</button>
              </div>
            ) : comanda.itens.map(item => (
              <div key={item.id} style={{
                background: '#1a1a1a', border: '1px solid #333',
                borderRadius: 8, padding: 12, marginBottom: 8,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>
                    {item.quantidade}× {item.produto_nome}
                  </div>
                  <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>
                    R$ {parseFloat(item.subtotal).toFixed(2).replace('.', ',')}
                  </div>
                  {item.observacao && (
                    <div style={{ fontSize: 11, color: '#FF6B00', marginTop: 4 }}>📝 {item.observacao}</div>
                  )}
                </div>
                <button onClick={() => removerItem(item.id)} style={{
                  background: 'rgba(230,57,70,0.2)', border: 'none',
                  color: '#ff6b7a', padding: 8, borderRadius: 6, cursor: 'pointer'
                }}>🗑️</button>
              </div>
            ))}

            {/* Resumo */}
            {comanda.itens.length > 0 && (
              <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, padding: 14, marginTop: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13, color: '#aaa' }}>
                  <span>Subtotal</span>
                  <span>R$ {parseFloat(comanda.subtotal).toFixed(2).replace('.', ',')}</span>
                </div>
                {parseFloat(comanda.desconto) > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13, color: '#22c55e' }}>
                    <span>Desconto</span>
                    <span>- R$ {parseFloat(comanda.desconto).toFixed(2).replace('.', ',')}</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 8, borderTop: '1px solid #333', fontSize: 16, fontWeight: 800 }}>
                  <span>Total</span>
                  <span style={{ color: '#FF6B00' }}>R$ {parseFloat(comanda.total).toFixed(2).replace('.', ',')}</span>
                </div>
              </div>
            )}
          </>
        )}

        {/* Tab: Adicionar */}
        {tab === 'adicionar' && (
          <>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="🔍 Buscar produto..."
              style={{ width: '100%', padding: 12, background: '#1a1a1a', border: '1px solid #333',
                color: '#fff', borderRadius: 8, fontSize: 14, marginBottom: 14 }} />
            {Object.entries(produtos).map(([cat, itens]) => {
              const filtrados = itens.filter(p =>
                p.disponivel && p.nome.toLowerCase().includes(busca.toLowerCase())
              );
              if (filtrados.length === 0) return null;
              return (
                <div key={cat} style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#999', marginBottom: 8, textTransform: 'uppercase' }}>{cat}</div>
                  {filtrados.map(p => (
                    <div key={p.id} onClick={() => adicionarItem(p)} style={{
                      background: '#1a1a1a', border: '1px solid #333', borderRadius: 8,
                      padding: 12, marginBottom: 6, cursor: 'pointer',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                    }}>
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 700 }}>{p.emoji} {p.nome}</div>
                        <div style={{ fontSize: 12, color: '#FF6B00', fontWeight: 700, marginTop: 2 }}>
                          R$ {parseFloat(p.preco).toFixed(2).replace('.', ',')}
                        </div>
                      </div>
                      <div style={{ background: '#FF6B00', color: '#fff', width: 32, height: 32,
                        borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 20, fontWeight: 700 }}>+</div>
                    </div>
                  ))}
                </div>
              );
            })}
          </>
        )}

        {/* Tab: Pagamento */}
        {tab === 'pagamento' && (
          <>
            <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, padding: 14, marginBottom: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 14 }}>
                <span>Total da comanda</span>
                <span style={{ fontWeight: 700 }}>R$ {parseFloat(comanda.total).toFixed(2).replace('.', ',')}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 14, color: '#22c55e' }}>
                <span>Pago</span>
                <span style={{ fontWeight: 700 }}>R$ {totalPago.toFixed(2).replace('.', ',')}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 8, borderTop: '1px solid #333', fontSize: 16, fontWeight: 800 }}>
                <span>Restante</span>
                <span style={{ color: restante > 0.01 ? '#ef4444' : '#22c55e' }}>
                  R$ {restante.toFixed(2).replace('.', ',')}
                </span>
              </div>
            </div>

            <button onClick={() => { setNovoPag({ forma: 'dinheiro', valor: restante > 0 ? restante.toFixed(2) : '' }); setModalPagamento(true); }} style={{
              width: '100%', padding: 14, background: 'linear-gradient(90deg,#e63946,#FF6B00)',
              border: 'none', color: '#fff', borderRadius: 8, fontSize: 14, fontWeight: 700,
              cursor: 'pointer', marginBottom: 14
            }}>➕ Adicionar Pagamento</button>

            {comanda.pagamentos.length > 0 && (
              <>
                <div style={{ fontSize: 13, color: '#999', marginBottom: 8 }}>Pagamentos registrados:</div>
                {comanda.pagamentos.map(p => (
                  <div key={p.id} style={{
                    background: '#1a1a1a', border: '1px solid #333', borderRadius: 8,
                    padding: 12, marginBottom: 6,
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                  }}>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700 }}>{formasPagLabel[p.forma]}</div>
                      <div style={{ fontSize: 12, color: '#22c55e', fontWeight: 700 }}>
                        R$ {parseFloat(p.valor).toFixed(2).replace('.', ',')}
                      </div>
                    </div>
                    <button onClick={() => removerPagamento(p.id)} style={{
                      background: 'rgba(230,57,70,0.2)', border: 'none',
                      color: '#ff6b7a', padding: 6, borderRadius: 6, cursor: 'pointer', fontSize: 12
                    }}>🗑️</button>
                  </div>
                ))}
              </>
            )}
          </>
        )}
      </div>

      {/* Barra inferior fixa */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        background: '#111', borderTop: '1px solid #333', padding: 12,
        display: 'flex', gap: 8
      }}>
        <button onClick={cancelarComanda} style={{
          flex: 1, padding: 12, background: 'rgba(230,57,70,0.2)',
          border: '1px solid rgba(230,57,70,0.4)', color: '#ff6b7a',
          borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700
        }}>Cancelar</button>
        <button onClick={fecharComanda} disabled={restante > 0.01} style={{
          flex: 2, padding: 12,
          background: restante > 0.01 ? '#333' : 'linear-gradient(90deg,#22c55e,#16a34a)',
          border: 'none', color: '#fff', borderRadius: 8,
          cursor: restante > 0.01 ? 'not-allowed' : 'pointer',
          fontSize: 14, fontWeight: 700, opacity: restante > 0.01 ? 0.5 : 1
        }}>
          {restante > 0.01 ? `Falta R$ ${restante.toFixed(2)}` : '✅ Fechar Comanda'}
        </button>
      </div>

      {/* Modal pagamento */}
      {modalPagamento && (
        <div onClick={() => setModalPagamento(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 100
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#1a1a1a', borderRadius: '16px 16px 0 0',
            padding: 20, width: '100%', maxWidth: 500,
            border: '1px solid #333', borderBottom: 'none'
          }}>
            <h3 style={{ fontSize: 16, marginBottom: 14 }}>💰 Novo Pagamento</h3>
            <label style={{ fontSize: 12, color: '#999', display: 'block', marginBottom: 4 }}>Forma</label>
            <select value={novoPag.forma} onChange={e => setNovoPag({ ...novoPag, forma: e.target.value })} style={{
              width: '100%', padding: 12, background: '#222', border: '1px solid #333',
              color: '#fff', borderRadius: 8, fontSize: 14, marginBottom: 12
            }}>
              <option value="dinheiro">💵 Dinheiro</option>
              <option value="pix">📱 PIX</option>
              <option value="cartao_credito">💳 Cartão de Crédito</option>
              <option value="cartao_debito">💳 Cartão de Débito</option>
              <option value="outro">📌 Outro</option>
            </select>

            <label style={{ fontSize: 12, color: '#999', display: 'block', marginBottom: 4 }}>Valor (R$)</label>
            <input type="number" step="0.01" value={novoPag.valor} onChange={e => setNovoPag({ ...novoPag, valor: e.target.value })}
              autoFocus placeholder="0,00"
              style={{ width: '100%', padding: 12, background: '#222', border: '1px solid #333',
                color: '#fff', borderRadius: 8, fontSize: 18, fontWeight: 700, marginBottom: 16 }} />

            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setModalPagamento(false)} style={{
                flex: 1, padding: 12, background: '#333', border: 'none',
                color: '#fff', borderRadius: 8, cursor: 'pointer'
              }}>Cancelar</button>
              <button onClick={adicionarPagamento} style={{
                flex: 2, padding: 12, background: 'linear-gradient(90deg,#e63946,#FF6B00)',
                border: 'none', color: '#fff', borderRadius: 8, cursor: 'pointer', fontWeight: 700
              }}>Registrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
